// @flow

import callReasonAndDuration from "./call-reason-and-duration";
import employeeAbsence from "./employee-absence";
import type { SchemaFilterRules } from "../types";

const rules: SchemaFilterRules = {
  ...callReasonAndDuration,
  ...employeeAbsence,
};

export default rules;
